module.exports = __webpack_public_path__ + "img/purple-flowers.1089c9dd.jpeg";